






















































import estimatedShippingMixin from '@/product/mixins/estimatedShippingMixin'

import productServices from '@/product/services'
import { getSizeInputQuery } from '@/common/utils/common'
import { Prefecture } from '@/product/types'
import LocalStorageSerializer from '@/common/localStorageSerializer'
import { LOCAL_STORAGE_KEY } from '@/product/const'
import {
  BQ_EVENT_NAMES,
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  EVENT_LABELS,
  gaEventTracker,
  raksulBQEventTracker
} from '@/common/utils'

export default estimatedShippingMixin.extend({
  data(): {
    prefectures: readonly Prefecture[]
    prefectureId: string
  } {
    return {
      prefectures: [],
      prefectureId: ''
    }
  },
  computed: {
    shortestDeliveryDate(): string | undefined {
      return this.$_estimate.shortestDeliveryDate
    },
    convenienceStoreShortestDeliveryDate(): string | undefined {
      return this.$_estimate.convenienceStoreShortestDeliveryDate
    },
    selectedPrefecture(): Prefecture | undefined {
      const prefecture = this.prefectures.find(item => item.id === this.prefectureId)
      return prefecture
    }
  },
  async created() {
    this.prefectures = await productServices.getPrefectures().then(res => res.prefectures)
    this.prefectureId = LocalStorageSerializer.get(LOCAL_STORAGE_KEY.PRODUCT_DETAIL_PREFECTURE)?.id || ''
    if (this.prefectureId) {
      this.$emit('onChangePrefecture', this.prefectureId)
    }
  },
  methods: {
    onChangePrefecture(prefectureId: string) {
      if (prefectureId) {
        LocalStorageSerializer.set(LOCAL_STORAGE_KEY.PRODUCT_DETAIL_PREFECTURE, this.selectedPrefecture)
        this.$emit('onChangePrefecture', prefectureId)
      }
      raksulBQEventTracker({
        eventName: BQ_EVENT_NAMES.CHANGE_PREFECTURE,
        data: {
          prefectureName: this.selectedPrefecture?.name || '',
          productName: this.$_storeSate.productDetail.product.displayName,
          sizeInput: getSizeInputQuery(this.$_storeSate.sizeInput)
        }
      })
      gaEventTracker(
        EVENT_CATEGORIES.PRODUCT_DETAIL,
        EVENT_ACTIONS.CHANGE,
        EVENT_LABELS.CHANGE_PREFECTURE
      )
    }
  }
})
